import { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { selectCountry } from '../../../../common/category/store/slice'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { DEFAULT_CODE } from '../../../../layout/header/search/constants'
import {
  changeTextSearch,
  reset,
  selectTextSearch,
} from '../../../domesticSearch/searchList/store/slice'
import classes from '../index.module.scss'
import { selectData, selectLoading } from '../store/slice'
import { getInternationalCompany } from '../store/thunk'
import { SearchResultItem } from './SearchResultItem'

export const SearchResults = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const text = searchParams.get('text')

  const data = useSelector(selectData)
  const loading = useSelector(selectLoading)
  const textSearch = useSelector(selectTextSearch)
  const country = useSelector(selectCountry)

  useEffect(() => {
    dispatch(changeTextSearch(text))
    return () => dispatch(reset())
  }, [])

  useEffect(() => {
    if (!country.code || country.code === DEFAULT_CODE) return

    dispatch(
      getInternationalCompany({
        SearchParam: textSearch,
        CountryCode: country.code,
        KompanySearchType: 'Full',
      }),
    )
  }, [textSearch, country])

  return (
    <div className="positionRelative h100">
      {loading && <Loading />}
      {!loading && (
        <div className={classes.searchResults}>
          <ScrollComponent>
            {data.map((item, index) => (
              <Fragment key={item.registrationNumber}>
                {index !== 0 && (
                  <Element
                    className={classes.divider}
                    style={{ borderTopColor: '#e8eaed' }}
                  />
                )}
                <SearchResultItem data={item} />
              </Fragment>
            ))}
          </ScrollComponent>
        </div>
      )}
    </div>
  )
}
